export const importNewList = {
	title: "Import new guest list",
	secondTitle: "Import new or existing list",
	middleTitle: "To import a new list just upload a spreadsheet",
	format: "Worksheet format",
	altText: "Example of how the spreadsheet to be imported should be structured",
	sheetFileName: "Guest list",
	errorMessageDefault:
		"Invalid worksheet, download it again and make the necessary changes. In case of empty lines in red, delete and try again.",
	importList: "Import an existing list into this event",
	selectText: "Import list from such Venue for this event",
	relationUsers: "Customers to be added to the list",
	form: {
		listName: "List name",
		colorSelect: "Assign a color",
		expiresAtDate: "List expiration",
		at: "at",
		errorName: "Enter the name of the list",
		errorExpires: "Expired date and time.",
		couvertPercentage: "Discount on couvert",
		entranceIds: {
			label: "Associated Entry",
			placeholder: "Select associated entry type",
		},
		description: {
			label: "Description",
			placeholder: "Add a note to your list if you want",
			limit: "{{count}} characters left",
		},
		documentIsRequired: "Document is required",
		canBeInvitedByLink: "Allow share list via link",
		addGuestTimeLimit: "Guest insertion deadline",
	},
	successMessage: "Spreadsheet successfully imported",
	alert: "Before importing the spreadsheet, ensure that all blank lines are removed",
	goBackText: "Go back to lists",
	or: "or",
	goBackModal: {
		title: "Leave",
		leavePage: "Leave page",
		description:
			"When you leave this page you will lose all the information you have filled in, do you want to exit anyway?",
	},
	error: "Error",
	list: "List",
	message: "Message",
};
